/* Voltix theme JavaScript – Shopify Ajax Cart API, predictive search, wishlist, product & filter UI */
(function () {
  'use strict';

  var V = window.Voltix || {};
  var R = V.routes || {};
  var S = V.strings || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function ls(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v || d; } catch (e) { return d; } }
  function sv(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- Cart drawer & Ajax Cart API ---------- */
  function openCart() {
    var d = $('#drawer'), o = $('.overlay');
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('show');
    var x = $('[data-cart-close]', d);
    if (x) x.focus();
  }
  function closeCart() {
    var d = $('#drawer'), o = $('.overlay');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('show');
  }
  function useDrawer() {
    return V.cartType !== 'page' && !document.body.classList.contains('template-cart') && !!$('#drawer');
  }
  function applyCartSection(html) {
    if (!html) return;
    var fresh = $('#drawer', parse(html)), cur = $('#drawer');
    if (!fresh || !cur) return;
    cur.innerHTML = fresh.innerHTML;
    var c = fresh.getAttribute('data-count') || '0';
    cur.setAttribute('data-count', c);
    $$('[data-cart-count]').forEach(function (e) { e.textContent = c; });
  }
  function refreshDrawer() {
    return fetch(R.cart + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { applyCartSection(j['cart-drawer']); });
  }
  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || S.error);
        return j;
      });
    });
  }
  function addToCart(id, qty, title, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    return cartPost(R.cartAdd + '.js', {
      items: [{ id: Number(id), quantity: Number(qty) || 1 }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (j) {
      applyCartSection(j.sections && j.sections['cart-drawer']);
      toast((title ? title + ' ' : '') + S.added);
      if (useDrawer()) openCart();
      else if (V.cartType === 'page') window.location.href = R.cart;
    }).catch(function (e) {
      toast(e.message || S.error);
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
    });
  }
  function changeLine(line, qty) {
    return cartPost(R.cartChange + '.js', {
      line: Number(line),
      quantity: Number(qty),
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (j) {
      applyCartSection(j.sections && j.sections['cart-drawer']);
    }).catch(function (e) {
      toast(e.message || S.error);
      refreshDrawer();
    });
  }

  /* ---------- Wishlist (stored per browser, by product handle) ---------- */
  var wish = ls('voltix_wish', []);
  function syncWish() {
    $$('[data-wish-count]').forEach(function (e) { e.textContent = wish.length; });
    $$('[data-wish-toggle]').forEach(function (b) {
      var on = wish.indexOf(b.getAttribute('data-wish-toggle')) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = b.classList.contains('heart') ? (on ? '♥' : '♡') : (on ? S.wishSaved : S.wishSave);
    });
  }
  function toggleWish(handle) {
    var i = wish.indexOf(handle);
    if (i > -1) { wish.splice(i, 1); toast(S.wishRemoved); } else { wish.push(handle); toast(S.wishAdded); }
    sv('voltix_wish', wish);
    syncWish();
    if ($('[data-wishlist]')) renderWishlist();
  }
  function renderWishlist() {
    var box = $('[data-wishlist]');
    if (!box) return;
    var grid = $('[data-wishlist-grid]', box), empty = $('[data-wishlist-empty]', box);
    if (!wish.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; return; }
    Promise.all(wish.map(function (h) {
      return fetch(R.root + 'products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.join('').trim();
      grid.innerHTML = html;
      grid.hidden = !html;
      empty.hidden = !!html;
      syncWish();
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = $('#q'), box = $('#sug');
    if (!input || !box || input.__init) return;
    input.__init = true;
    var timer, seq = 0;
    function hide() { box.style.display = 'none'; box.innerHTML = ''; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (!term) { hide(); return; }
      timer = setTimeout(function () {
        var n = ++seq;
        fetch(R.predictiveSearch + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=5&section_id=predictive-search')
          .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
          .then(function (html) {
            if (n !== seq) return;
            var out = $('[data-predictive]', parse(html));
            box.innerHTML = out ? out.innerHTML : '';
            box.style.display = box.innerHTML.trim() ? 'block' : 'none';
          }).catch(hide);
      }, 250);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.search')) hide(); });
  }

  /* ---------- Product page ---------- */
  function setMedia(root, thumb) {
    var img = $('[data-main-img]', root);
    if (img && thumb.getAttribute('data-src')) {
      img.src = thumb.getAttribute('data-src');
      img.alt = thumb.getAttribute('data-alt') || '';
    }
    $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('on', t === thumb); });
  }
  function initProduct(root) {
    if (root.__init) return;
    root.__init = true;
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var sectionId = root.getAttribute('data-section-id');
    var baseUrl = root.getAttribute('data-product-url');
    var reqId = 0;

    function currentVariant() {
      var sel = $$('[data-option]:checked', root).map(function (i) {
        return { p: i.getAttribute('data-option'), v: i.value };
      });
      if (!sel.length) return variants[0];
      return variants.filter(function (v) {
        return sel.every(function (s) { return v['option' + s.p] === s.v; });
      })[0];
    }
    function refreshSection(id) {
      var n = ++reqId;
      fetch(baseUrl + '?variant=' + id + '&section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (n !== reqId) return;
          var doc = parse(html);
          ['[data-price-block]', '[data-buy-buttons]', '[data-specs]'].forEach(function (sel) {
            var a = $(sel, doc), b = $(sel, root);
            if (a && b) b.innerHTML = a.innerHTML;
          });
          syncWish();
        }).catch(function () {});
    }
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var v = currentVariant();
      if (!v) {
        $$('[data-buy-buttons] button[type="submit"]', root).forEach(function (b) { b.disabled = true; });
        var add = $('[data-add-label]', root);
        if (add) add.textContent = S.unavailable;
        return;
      }
      $('[data-variant-input]', root).value = v.id;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      } catch (err) {}
      if (v.featured_image && v.featured_image.id) {
        var t = $('[data-thumb][data-image-id="' + v.featured_image.id + '"]', root);
        if (t) setMedia(root, t);
      }
      refreshSection(v.id);
    });
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th) { setMedia(root, th); return; }
      var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
      if (minus || plus) {
        var input = $('[data-qty-input]', root);
        var q = parseInt(input.value, 10) || 1;
        input.value = minus ? Math.max(1, q - 1) : q + 1;
      }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-product-form]')) return;
      if (e.submitter && e.submitter.name === 'checkout') return; /* "Buy now": native add + redirect to Shopify checkout */
      e.preventDefault();
      addToCart($('[data-variant-input]', form).value, $('[data-qty-input]', form).value, form.getAttribute('data-title'), e.submitter);
    });
  }

  /* ---------- Related products ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.__init) return;
      el.__init = true;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var n = $('[data-recommendations]', parse(html));
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; syncWish(); }
      }).catch(function () {});
    });
  }

  /* ---------- Global click / change / key handlers ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-cart-open]'))) {
      if (useDrawer()) { e.preventDefault(); openCart(); }
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      if (e.target.closest('a')) { closeCart(); return; }
      e.preventDefault(); closeCart(); return;
    }
    if ((t = e.target.closest('[data-add-to-cart]'))) {
      e.preventDefault();
      addToCart(t.getAttribute('data-variant-id'), 1, t.getAttribute('data-title'), t);
      return;
    }
    if ((t = e.target.closest('[data-line][data-qty]'))) {
      e.preventDefault();
      changeLine(t.getAttribute('data-line'), t.getAttribute('data-qty'));
      return;
    }
    if ((t = e.target.closest('[data-wish-toggle]'))) {
      e.preventDefault();
      toggleWish(t.getAttribute('data-wish-toggle'));
      return;
    }
    if ((t = e.target.closest('[data-menu-toggle]'))) {
      var m = $('#mmenu');
      if (m) { var open = m.classList.toggle('open'); t.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      return;
    }
    if ((t = e.target.closest('[data-filter-toggle]'))) {
      var f = $('#filt');
      if (f) { var o = f.classList.toggle('open'); t.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-range]');
    if (r) {
      var out = $('[data-range-out]', r.closest('div'));
      if (out) out.textContent = (r.getAttribute('data-prefix') || '') + r.value;
    }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.hasAttribute && el.hasAttribute('data-auto-submit') && el.form) {
      if (el.form.requestSubmit) el.form.requestSubmit(); else el.form.submit();
      return;
    }
    if (el.matches && el.matches('[data-cart-qty]')) {
      var form = el.closest('form');
      if (form) {
        var upd = $('[name="update"]', form);
        if (form.requestSubmit && upd) form.requestSubmit(upd); else form.submit();
      }
    }
  });

  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-facets]')) {
      $$('[data-range]', e.target).forEach(function (r) { if (r.value === r.getAttribute('max')) r.disabled = true; });
    }
  });

  /* ---------- Init ---------- */
  function init() {
    initSearch();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    syncWish();
    renderWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init); /* theme editor */
})();
